/**
 * Diretiva responsável por criar um componente para cadastramento/edição de contatos
 * (números de telefone, endereço de e-mail, Facebook, etc.). 
 */

angular.module("avlib").directive("avContactEditor", function(){
	return {
		template: require("!html-loader!./ContactEditorTemplate.html"),

		restrict: "E",
		scope: {
			phones: '=',
			eAddresses: '=',
			deletedPhones: '=',
			deletedAddresses: '=',
			callbacks: '=',
			mode: '@',
		},
		controller: 'contactEditorController'
	};
});
